(function () {
  if (window.SoluscentShippingProtection) return;

  var config = window.ShopifyShippingProtection || {};
  var VARIANT_ID = config.variantId;
  var PRODUCT_HANDLE = 'shipping-protection';

  if (!VARIANT_ID) return;

  // Public line-item property (no leading underscore -- an underscore-
  // prefixed property is "private" and Shopify never shows it to the
  // customer, including in Checkout) so Shopify's own hosted Checkout
  // renders it under the line item automatically. This store isn't
  // Shopify Plus, so there is no supported way to touch Checkout's DOM
  // directly -- a public cart line-item property is the correct,
  // supported mechanism for this. Only ever attached to this one
  // variant, via addProtectionItem() below -- never to a candle or gift
  // set line, which are added through product-form.js's own unrelated
  // flow.
  //
  // Copy deliberately doesn't lead with "Optional" or "Remove" -- that
  // phrasing read as an invitation to cancel. "Protection selected"
  // states the customer's choice as already made; "Manage this option in
  // your cart" still tells them where to change it, without prompting
  // the change.
  var PROTECTION_PROPERTY_KEY = 'Protection selected';
  var PROTECTION_PROPERTY_VALUE = 'Manage this option in your cart.';
  var PROTECTION_PROPERTIES = {};
  PROTECTION_PROPERTIES[PROTECTION_PROPERTY_KEY] = PROTECTION_PROPERTY_VALUE;

  function hasProtectionProperty(item) {
    return !!(item && item.properties && item.properties[PROTECTION_PROPERTY_KEY] === PROTECTION_PROPERTY_VALUE);
  }

  var reconcileInFlight = false;
  var reconcileQueued = false;

  // Single reliable identifier for the Delivery Protection line item, reused
  // everywhere a cart item needs to be classified (list filtering, cart
  // count, empty-cart detection, quantity normalization). Never match on
  // product/variant title.
  function isDeliveryProtection(item) {
    if (!item) return false;
    if (item.id === VARIANT_ID) return true;
    if (item.handle === PRODUCT_HANDLE) return true;
    return false;
  }

  function getMerchandiseQuantity(items) {
    var total = 0;
    (items || []).forEach(function (item) {
      if (!isDeliveryProtection(item)) total += item.quantity;
    });
    return total;
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  // Soluscent (perf): transient, purely visual "about to be empty" state --
  // see reconcileWithCart()'s normalQuantity === 0 branch. Reuses the
  // same elements the real .is-empty toggle already hides (see
  // assets/component-cart.css's `.is-empty .cart__footer` etc.), under a
  // separate class so it can never be confused with (or fight over) the
  // real, server-confirmed empty state that cart.js/patchSections() below
  // apply once the response actually arrives.
  function markEmptying() {
    var mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter) mainCartFooter.classList.add('soluscent-cart-emptying');
  }

  function clearEmptying() {
    var mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter) mainCartFooter.classList.remove('soluscent-cart-emptying');
  }

  // Perf fix: this used to unconditionally request BOTH the full
  // 'cart-drawer' section AND the full-cart-page sections (main-cart-
  // items/main-cart-footer) on every single toggle, regardless of which
  // one the customer could actually see. The <cart-drawer> element is
  // present in the DOM on every page (it lives in the header, just
  // hidden/closed by CSS), so this fired even while standing on the full
  // /cart page with the drawer closed -- Shopify still had to server-
  // render the *entire* cart-drawer section (item list, recommendations,
  // etc., ~32KB of Liquid) as dead weight on every request. Live network
  // trace (peach-oolong-candle, drawer context, cb=1786...) measured a
  // single such POST /cart/update taking ~870ms for exactly this reason.
  // Dawn's own native item-removal flow (assets/cart.js CartItems vs
  // assets/cart-drawer.js CartDrawerItems) already asks for a different,
  // narrower section list depending on which one it's running in --
  // this mirrors that same split instead of requesting the union of both
  // every time.
  function getSectionIds() {
    var ids = [];
    var onCartPage = !!(document.getElementById('main-cart-items') || document.getElementById('main-cart-footer'));

    if (onCartPage) {
      var mainCartFooter = document.getElementById('main-cart-footer');
      if (mainCartFooter && mainCartFooter.dataset.id) {
        ids.push(mainCartFooter.dataset.id);
      }

      var mainCartItems = document.getElementById('main-cart-items');
      if (mainCartItems && mainCartItems.dataset.id) {
        ids.push(mainCartItems.dataset.id);
      }
    } else if (document.querySelector('cart-drawer')) {
      // Toggle only ever renders inside the drawer or the full cart page
      // (see patchSections() below) -- if we're not on the cart page,
      // this is the drawer, so just render the drawer's own section.
      ids.push('cart-drawer');
    }

    if (document.getElementById('cart-icon-bubble')) {
      ids.push('cart-icon-bubble');
    }

    return ids;
  }

  function patchSections(sections, itemCount) {
    if (!sections) return;

    if (sections['cart-drawer']) {
      var cartDrawerRoot = document.querySelector('#CartDrawer');
      var parsedDrawer = parseHTML(sections['cart-drawer']).querySelector('#CartDrawer');
      if (cartDrawerRoot && parsedDrawer) cartDrawerRoot.innerHTML = parsedDrawer.innerHTML;
    }

    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var parsedBubble = parseHTML(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (bubble && parsedBubble) bubble.innerHTML = parsedBubble.innerHTML;
    }

    var becameEmpty = itemCount === 0;
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) cartDrawerEl.classList.toggle('is-empty', becameEmpty);

    var mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter && mainCartFooter.dataset.id && sections[mainCartFooter.dataset.id]) {
      var parsedFooterRoot = parseHTML(sections[mainCartFooter.dataset.id]);

      if (becameEmpty) {
        // Soluscent: Delivery Protection auto-removes itself (see
        // reconcile() below) whenever the last ordinary merchandise line
        // is removed, via this same mutateCart()/patchSections() path --
        // *not* assets/cart.js's updateQuantity(). That means the moment
        // the cart truly becomes empty can land here instead of there,
        // and this path never used to flip the page into Dawn's server-
        // rendered "cart == empty" branch (Delivery Protection, the
        // free-shipping bar, totals, the Gift Upgrade module, and the
        // survey/checkout UI all disappearing) -- it only ever patched
        // those pieces individually, which is meaningless once the
        // section's whole structure has changed. Swap the section's
        // entire rendered HTML back in instead (same response already
        // fetched by mutateCart()/addProtectionItem(), no extra
        // request), mirroring the identical fix in assets/cart.js.
        var sourceFooterRoot = parsedFooterRoot.getElementById('main-cart-footer');
        if (sourceFooterRoot) mainCartFooter.innerHTML = sourceFooterRoot.innerHTML;
      } else {
        // Soluscent: the Delivery Protection toggle and the free-shipping bar
        // both live in main-cart-footer.liquid *outside* .js-contents (the
        // subtotal block), so patching only .js-contents left the toggle's
        // on/off state and the free-shipping message stuck at whatever the
        // page originally rendered -- on the full cart page, clicking it (or
        // reconcile() auto-adding it on first load) updated the cart
        // correctly but the visible switch and message never moved. Patch
        // those two directly; leave the survey and Checkout button alone,
        // since neither is affected by a Delivery Protection change.
        var dpTarget = mainCartFooter.querySelector('.soluscent-shipping-protection');
        var dpSource = parsedFooterRoot.querySelector('.soluscent-shipping-protection');
        if (dpTarget && dpSource) dpTarget.replaceWith(dpSource);

        var freeShipTarget = mainCartFooter.querySelector('.soluscent-free-shipping');
        var freeShipSource = parsedFooterRoot.querySelector('.soluscent-free-shipping');
        if (freeShipTarget && freeShipSource) freeShipTarget.replaceWith(freeShipSource);

        var footerTarget = mainCartFooter.querySelector('.js-contents');
        var parsedFooter = parsedFooterRoot.querySelector('.js-contents');
        if (footerTarget && parsedFooter) footerTarget.innerHTML = parsedFooter.innerHTML;
      }

      mainCartFooter.classList.toggle('is-empty', becameEmpty);
      // The real, server-confirmed content has now landed either way --
      // the transient pre-hide from markEmptying() (if it ran) has done
      // its job and must not linger under whatever this response's own
      // fresh markup turns out to need.
      mainCartFooter.classList.remove('soluscent-cart-emptying');
    }

    var mainCartItems = document.getElementById('main-cart-items');
    var cartItemsEl = document.querySelector('cart-items');
    if (mainCartItems && mainCartItems.dataset.id && sections[mainCartItems.dataset.id]) {
      if (becameEmpty && cartItemsEl) {
        var sourceCartItems = parseHTML(sections[mainCartItems.dataset.id]).querySelector('cart-items');
        if (sourceCartItems) cartItemsEl.innerHTML = sourceCartItems.innerHTML;
      } else {
        var itemsTarget = mainCartItems.querySelector('.js-contents');
        var parsedItems = parseHTML(sections[mainCartItems.dataset.id]).querySelector('.js-contents');
        if (itemsTarget && parsedItems) itemsTarget.innerHTML = parsedItems.innerHTML;
      }
    }
    if (cartItemsEl) cartItemsEl.classList.toggle('is-empty', becameEmpty);
  }

  function mutateCart(updates, attributes) {
    var body = {
      updates: updates,
      sections: getSectionIds(),
      sections_url: window.location.pathname,
    };
    if (attributes) body.attributes = attributes;

    return fetch(window.routes.cart_update_url, Object.assign({}, fetchConfig(), { body: JSON.stringify(body) }))
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state && state.sections) patchSections(state.sections, state.item_count);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shipping-protection', cartData: state });
        return state;
      });
  }

  // /cart/update.js's "updates" mechanism (used by mutateCart above) can
  // only set an existing line's quantity -- it has no way to attach line-
  // item properties. Properties can only be set when a line is created,
  // via /cart/add.js. This is the only path that ever adds the Delivery
  // Protection variant, so PROTECTION_PROPERTIES always rides along.
  function addProtectionItem(attributes) {
    var addBody = {
      items: [{ id: VARIANT_ID, quantity: 1, properties: PROTECTION_PROPERTIES }],
      sections: getSectionIds(),
      sections_url: window.location.pathname,
    };

    return fetch(window.routes.cart_add_url, Object.assign({}, fetchConfig(), { body: JSON.stringify(addBody) }))
      .then(function (response) {
        return response.json();
      })
      .then(function (addState) {
        var sections = addState && addState.sections;

        // /cart/add.js's response describes the line item that was just
        // added, not the full cart -- get that from a second request,
        // which also returns the fresh, correct .attributes/.items other
        // cartUpdate subscribers (this module's own drawer-auto-close
        // check, the source-survey sync) expect. When there's an
        // attribute to set, /cart/update.js both sets it and returns the
        // full cart in one step; otherwise a plain read-only /cart.js
        // fetch gets the same shape without touching (and, per Shopify's
        // "attributes" replace-not-merge behaviour, risking) anything.
        if (attributes) {
          return fetch(
            window.routes.cart_update_url,
            Object.assign({}, fetchConfig(), { body: JSON.stringify({ attributes: attributes }) })
          )
            .then(function (response) {
              return response.json();
            })
            .then(function (state) {
              return { state: state, sections: sections };
            });
        }

        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.json();
          })
          .then(function (state) {
            return { state: state, sections: sections };
          });
      })
      .then(function (result) {
        if (result.sections) patchSections(result.sections, result.state && result.state.item_count);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shipping-protection', cartData: result.state });
        return result.state;
      });
  }

  // Silently removes the Delivery Protection line with no DOM patch, no
  // publish, no "sections" request -- used only as the first half of the
  // quiet remove-then-re-add migration for an existing line that predates
  // PROTECTION_PROPERTIES, so the customer only ever sees one, final,
  // already-correct update instead of a visible remove-then-add flash.
  function removeProtectionQuietly() {
    var updates = {};
    updates[VARIANT_ID] = 0;
    return fetch(
      window.routes.cart_update_url,
      Object.assign({}, fetchConfig(), { body: JSON.stringify({ updates: updates }) })
    ).then(function (response) {
      return response.json();
    });
  }

  // Soluscent (perf): a mutation that just happened (add/change/update,
  // or the pageshow resync in soluscent-cart-history-sync.js) already
  // returns the full, current cart as its response -- the exact same
  // shape /cart.js itself returns. reconcile() used to always throw that
  // away and do its own read-only GET /cart.js before deciding anything,
  // which serialized a whole extra round trip in front of every single
  // mutation-triggered check (measured live: ~150-200ms added to every
  // delete/quantity-change/add, entirely spent re-fetching data already
  // in hand). Call sites that already know the current cart pass it in;
  // reconcile() only falls back to fetching when it doesn't have it (the
  // page's initial DOMContentLoaded check, and a queued re-run after a
  // reconcile that was already in flight).
  function reconcileWithCart(cart) {
    var protectionItem = null;
    var normalQuantity = 0;

    (cart.items || []).forEach(function (item) {
      if (isDeliveryProtection(item)) {
        protectionItem = item;
      } else {
        normalQuantity += item.quantity;
      }
    });

    var optedOut = !!(cart.attributes && cart.attributes.shipping_protection_opted_out === 'true');

    if (normalQuantity === 0) {
      if (protectionItem || optedOut) {
        // Soluscent (perf): this mutateCart() call is the one that
        // actually brings the cart to true item_count === 0 and (via
        // patchSections()'s becameEmpty branch) swaps in the real empty-
        // cart markup -- but that swap still has to wait on this
        // request's own round trip. Rather than leave the *previous*
        // response's now-stale non-empty footer (Delivery Protection row,
        // Estimated Total, Checkout) visible for that entire wait, hide
        // it the instant we know -- from data already in hand, no extra
        // request -- that it's about to be replaced. This never asserts
        // a specific empty-cart total or count (that still only ever
        // comes from the real response); it only withholds content that
        // is already known to be stale. If this request fails, the
        // catch below immediately reveals the footer again so nothing is
        // ever left permanently hidden on a false premise.
        markEmptying();
        var clearUpdates = {};
        clearUpdates[VARIANT_ID] = 0;
        return mutateCart(clearUpdates, { shipping_protection_opted_out: '' });
      }
      return Promise.resolve();
    }

    if (protectionItem) {
      // An existing line from before PROTECTION_PROPERTIES existed
      // (or one that otherwise lost it) -- quietly remove and
      // re-add with the property attached, rather than leaving it
      // permanently without the Checkout note. The quiet removal
      // has no visible effect on its own; addProtectionItem()
      // immediately after is the only update the customer sees.
      if (!hasProtectionProperty(protectionItem)) {
        return removeProtectionQuietly().then(function () {
          return addProtectionItem(null);
        });
      }
      if (protectionItem.quantity !== 1) {
        var fixUpdates = {};
        fixUpdates[VARIANT_ID] = 1;
        return mutateCart(fixUpdates, null);
      }
      return Promise.resolve();
    }

    if (optedOut) return Promise.resolve();

    return addProtectionItem({ shipping_protection_opted_out: '' });
  }

  function reconcile(knownCart) {
    if (reconcileInFlight) {
      reconcileQueued = true;
      return;
    }
    reconcileInFlight = true;

    // Soluscent (perf): only trust knownCart when it's actually shaped
    // like the full cart object (/cart.js, /cart/change.js and /cart/
    // update.js all return this shape). A single-item /cart/add.js
    // response (product-form.js's normal Add to Cart submission) returns
    // just the added line item's own fields, with no item_count/items at
    // the cart level -- treating that as the whole cart would read as
    // "cart has nothing in it" and could skip adding Delivery Protection
    // on a customer's very first add. Any source not shaped this way
    // safely falls back to the original read, same as before this
    // change.
    var hasUsableCart = knownCart && typeof knownCart.item_count === 'number' && Array.isArray(knownCart.items);

    var cartPromise = hasUsableCart
      ? Promise.resolve(knownCart)
      : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
          return response.json();
        });

    cartPromise
      .then(reconcileWithCart)
      .catch(function (e) {
        console.error(e);
        clearEmptying();
        // The toggle can be showing an optimistic "selected + disabled"
        // state right now (see snippets/soluscent-shipping-protection.
        // liquid's sp_pending) if this reconcile() run was the one meant
        // to turn that into the real thing. If the underlying request
        // failed, that optimistic state must not be left standing --
        // the customer would see "selected" while the cart genuinely has
        // no Protection line. Only correct toggles that are actually
        // disabled right now (i.e. genuinely in that optimistic/pending
        // state) -- a toggle that's enabled and already correctly "on"
        // from a real, previously-confirmed line item must not be
        // touched just because this unrelated background check failed.
        var pendingToggles = document.querySelectorAll('[data-shipping-protection-toggle][disabled]');
        if (pendingToggles.length > 0) {
          setToggleVisualState(false);
          setTogglesDisabled(false);
          document.querySelectorAll('[data-shipping-protection]').forEach(function (container) {
            showError(container);
          });
        }
      })
      .finally(function () {
        reconcileInFlight = false;
        if (reconcileQueued) {
          reconcileQueued = false;
          reconcile();
        }
      });
  }

  function setTogglesDisabled(disabled) {
    document.querySelectorAll('[data-shipping-protection-toggle]').forEach(function (toggle) {
      toggle.disabled = disabled;
    });
  }

  // Optimistic UI: flips only the switch's own visual state (.is-on / the
  // CSS-driven knob position, plus its aria-checked value for screen
  // readers) -- never price or subtotal text, which always stays tied to
  // the real server response via patchSections(). Applied to every
  // toggle element (drawer copy and cart-page copy can both be in the DOM
  // at once), matching setTogglesDisabled()'s existing "affect all
  // toggles" pattern.
  function setToggleVisualState(isOnNow) {
    document.querySelectorAll('[data-shipping-protection-toggle]').forEach(function (toggle) {
      toggle.classList.toggle('is-on', isOnNow);
      toggle.setAttribute('aria-checked', isOnNow ? 'true' : 'false');
    });
  }

  function showError(container) {
    if (!container) return;
    var errorEl = container.querySelector('[data-shipping-protection-error]');
    if (errorEl) errorEl.hidden = false;
  }

  function hideErrors() {
    document.querySelectorAll('[data-shipping-protection-error]').forEach(function (errorEl) {
      errorEl.hidden = true;
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-shipping-protection-toggle]');
    if (!toggle || toggle.disabled) return;

    var container = toggle.closest('[data-shipping-protection]');
    var isOn = toggle.classList.contains('is-on');

    hideErrors();
    setTogglesDisabled(true);
    // Flip the switch immediately rather than waiting ~1-1.5s for the
    // network round trip -- the click registers as instant. Reverted in
    // the .catch() below on failure; on success it's simply overwritten
    // moments later by the real server-rendered state from
    // patchSections(), so there's never a moment where the switch shows
    // something the server disagrees with for longer than one request.
    setToggleVisualState(!isOn);

    var request;
    if (isOn) {
      var updates = {};
      updates[VARIANT_ID] = 0;
      request = mutateCart(updates, { shipping_protection_opted_out: 'true' });
    } else {
      // Turning it back on always goes through addProtectionItem() --
      // the only path that can attach PROTECTION_PROPERTIES -- rather
      // than mutateCart()'s quantity-only "updates", which has no way
      // to set line-item properties.
      request = addProtectionItem({ shipping_protection_opted_out: '' });
    }

    request
      .catch(function (e) {
        console.error(e);
        setToggleVisualState(isOn); // revert -- the request never actually succeeded
        showError(container);
        return reconcile();
      })
      .finally(function () {
        setTogglesDisabled(false);
      });
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('#cart-icon-bubble')) reconcile();
  });

  // ── Delivery Protection information modal ─────────────────────────
  var modalEl = null;
  var modalOverlayEl = null;
  var modalTriggerEl = null;
  var modalBodyWasLocked = false;
  var modalCloseTimer = null;

  function getModalEls() {
    if (!modalEl) modalEl = document.getElementById('DeliveryProtectionModal');
    if (!modalOverlayEl) modalOverlayEl = document.getElementById('DeliveryProtectionOverlay');
    return !!(modalEl && modalOverlayEl);
  }

  function onModalKeydown(event) {
    if (event.code && event.code.toUpperCase() === 'ESCAPE') closeModal();
  }

  function openModal(trigger) {
    if (!getModalEls()) return;
    if (modalCloseTimer) {
      clearTimeout(modalCloseTimer);
      modalCloseTimer = null;
    }

    modalTriggerEl = trigger || null;
    modalBodyWasLocked = document.body.classList.contains('overflow-hidden');

    modalOverlayEl.hidden = false;
    modalEl.hidden = false;
    modalEl.getBoundingClientRect(); // force reflow so the open transition runs

    requestAnimationFrame(function () {
      modalOverlayEl.classList.add('is-open');
      modalEl.classList.add('is-open');
    });

    document.body.classList.add('overflow-hidden');
    document.addEventListener('keydown', onModalKeydown);

    trapFocus(modalEl, modalEl.querySelector('[data-shipping-protection-modal-close]'));
  }

  function closeModal() {
    if (!getModalEls() || modalEl.hidden) return;

    modalOverlayEl.classList.remove('is-open');
    modalEl.classList.remove('is-open');
    document.removeEventListener('keydown', onModalKeydown);

    var activeDrawer = document.querySelector('cart-drawer.active');
    if (activeDrawer) {
      var drawerContainer = activeDrawer.querySelector('.drawer__inner') || activeDrawer;
      trapFocus(drawerContainer, modalTriggerEl || undefined);
    } else {
      removeTrapFocus(modalTriggerEl);
    }
    modalTriggerEl = null;

    if (!modalBodyWasLocked) {
      document.body.classList.remove('overflow-hidden');
    }

    modalCloseTimer = setTimeout(function () {
      modalOverlayEl.hidden = true;
      modalEl.hidden = true;
    }, 320);
  }

  document.addEventListener('click', function (event) {
    var infoTrigger = event.target.closest('[data-shipping-protection-info-trigger]');
    if (infoTrigger) {
      event.preventDefault();
      openModal(infoTrigger);
      return;
    }

    if (event.target.closest('[data-shipping-protection-modal-close]')) {
      closeModal();
      return;
    }

    if (event.target.closest('[data-shipping-protection-modal-overlay]')) {
      closeModal();
    }
  });

  document.addEventListener('DOMContentLoaded', reconcile);
  // Soluscent: a standalone `pageshow`+`persisted` listener used to live
  // here, firing its own independent /cart.js read on every BFCache
  // restore. assets/soluscent-cart-history-sync.js now owns that trigger
  // for the whole page and publishes PUB_SUB_EVENTS.cartUpdate once it has
  // resynced, which reaches the subscriber below (reconcile() already
  // runs for any cartUpdate not sourced from 'shipping-protection' itself)
  // -- so Delivery Protection still reconciles on history restore, just
  // cascaded from that single fetch instead of a second parallel one.

  // If a cart mutation just dropped merchandise to zero (e.g. removing the
  // last ordinary item), close an already-open drawer immediately using its
  // own existing close animation, instead of letting it repaint into an
  // empty-cart / Delivery-Protection-only state first. This runs
  // synchronously off data already present on the event (no extra network
  // round trip), so it resolves in the same paint as the triggering DOM
  // update and never flashes an intermediate blank drawer.
  function maybeAutoCloseDrawer(cartData) {
    if (!cartData || !cartData.items) return;
    if (getMerchandiseQuantity(cartData.items) > 0) return;

    var drawer = document.querySelector('cart-drawer.active');
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
    }
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event && event.source === 'shipping-protection') return;
    if (event) maybeAutoCloseDrawer(event.cartData);
    reconcile(event && event.cartData);
  });

  // Immediate visual feedback for normal cart-item removal -- Cart Page
  // (<cart-items>) ONLY. <cart-drawer-items> (the Cart Drawer's separate
  // custom element, same base class, different tag -- see assets/cart-
  // drawer.js) is deliberately excluded: a closed drawer is hidden via
  // visibility:hidden, not display:none, so any visibility/offsetParent-
  // based check would incorrectly still match its hidden copy of the
  // same row. Checking the actual custom-element ancestor tag instead of
  // any visual state sidesteps that entirely. This is a capture-phase
  // listener on the same click that triggers Dawn's own
  // cartItems.updateQuantity(0) (assets/cart.js), so the row visibly
  // starts dimming before any other JS runs.
  document.addEventListener(
    'click',
    function (event) {
      var removeBtn = event.target.closest('cart-remove-button');
      if (!removeBtn) return;
      if (!removeBtn.closest('cart-items')) return;
      var row = removeBtn.closest('.cart-item');
      if (row) row.classList.add('soluscent-cart-item--removing');
    },
    true
  );

  // Failure recovery for the above. Dawn's own CartItems.updateQuantity()
  // catch block (assets/cart.js) does not publish any event and does not
  // touch this specific row on a failed /cart/change.js request -- on
  // success the row's entire markup gets replaced (which incidentally
  // clears the class too, but that's not something to depend on), while
  // on failure the SAME row's markup is left completely untouched, so
  // the "removing" class would otherwise stay stuck (dimmed, unclickable)
  // indefinitely with no way to retry. Wrapping fetch -- rather than
  // editing cart.js directly -- only *observes* the exact same promise
  // Dawn's own code already awaits and returns it completely unmodified;
  // this cannot change what Dawn (or Sticky Add to Cart, quick-add, or
  // anything else on the page) sees, receives, or how long it takes.
  var nativeCartFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartChange = url.indexOf('/cart/change') !== -1;
    var result = nativeCartFetch.apply(this, arguments);
    if (isCartChange) {
      result
        .then(function (response) {
          if (!response.ok) clearStuckRemovingRows();
        })
        .catch(function () {
          clearStuckRemovingRows();
        });
    }
    return result;
  };

  function clearStuckRemovingRows() {
    document.querySelectorAll('cart-items .soluscent-cart-item--removing').forEach(function (row) {
      row.classList.remove('soluscent-cart-item--removing');
    });
  }

  window.SoluscentShippingProtection = { reconcile: reconcile };
})();
